import type { UsePriceDisplayReturn } from '@terminal/react-query-hooks/prices/usePriceDisplay';

type Price = NonNullable<UsePriceDisplayReturn['priceData']>['price'];

export const getDisplayPrice = (price: Price, isWindowComplete?: boolean) => {
  const { marketHours } = price.primary;
  const { secondary } = price;

  if (
    !isWindowComplete &&
    (marketHours.isPreMarket || marketHours.isAfterMarket) &&
    secondary?.price !== undefined &&
    secondary.isLive &&
    secondary.priceChange
  ) {
    return secondary;
  }

  return price.primary;
};
